export default __webpack_public_path__ + "static/media/17.0c6beb30.jpg";